import * as authSelectors from '@redux/reducers/auth';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Spinner, Tooltip } from 'reactstrap';
import Icon from 'utility/icomoon';

interface Props {
  id?: string;
  icon?: string;
  permissions?: any[];
  isDisabled?: boolean;
  handleClick: any;
  className?: string;
  tooltipMessage?: any;
  tooltipMessageDisabled?: any;
  visible?: boolean;
  color?: string;
  iconSize?: number;
  isLoading?: boolean;
  tooltipPosition?: string;
  styles?: any;
  children?: React.ReactNode;
}

const DefaultButton = (props: Props) => {
  const store = useSelector((state) => state);
  const {
    isDisabled = false,
    isLoading = false,
    handleClick,
    tooltipMessage,
    tooltipMessageDisabled,
    icon = 'Plus',
    id = 'DefaultButton',
    permissions,
    color,
    className = '',
    iconSize = 16,
    visible = true,
    tooltipPosition = 'top',
    children
  } = props;
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);

  // Determinar qué mensaje de tooltip mostrar
  const currentTooltipMessage = isDisabled ? tooltipMessageDisabled : tooltipMessage;

  return (!permissions || authSelectors.getAuthUserHasPermissionsAny(store, permissions)) &&
    visible ? (
    <Button.Ripple
      id={id}
      className={`${children ? '' : 'btn-icon'} ${isDisabled ? 'disabled' : ''} ${className}`}
      color={color ?? 'secondary'}
      disabled={isDisabled}
      onClick={handleClick}
      style={props.styles}
    >
      {isLoading ? (
        <>
          <Spinner as="span" animation="border" size={'sm'} role="status" aria-hidden="true" />
          {children && <span className="ml-1">{children}</span>}
        </>
      ) : (
        <>
          <Icon size={iconSize} icon={icon} />
          {children && <span className="ml-1">{children}</span>}
        </>
      )}

      {currentTooltipMessage && (
        <Tooltip
          placement={tooltipPosition}
          isOpen={tooltipOpen}
          target={id}
          toggle={toggle}
          trigger="click hover"
        >
          {currentTooltipMessage}
        </Tooltip>
      )}
    </Button.Ripple>
  ) : null;
};

export default DefaultButton;
